import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../SvgIcon";

export const GymLocationDesktop = ({
  gymLocations = [],
  onDelete = () => {},
  onEdit = () => {},
  onTimingModal = () => {},
  readOnly = false,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <div className="gym-location-table force-mobile-hidden">
      {/* header */}
      <div>
        <header>
          <div>
            <p className="s1">{t("gymLocationDesktop.gymName")}</p>
          </div>
          <div>
            <p className="s1">{t("gymLocationDesktop.location")}</p>
          </div>
          <div>
            <p className="s1">{t("gymLocationDesktop.googleMapLink")}</p>
          </div>
          <div>
            <p className="s1">{t("gymLocationDesktop.facilikey")}</p>
          </div>
          <div>
            <p className="s1">{t("gymLocationDesktop.action")}</p>
          </div>
        </header>
        {/* content */}
        {gymLocations.map((item, index) => {
          return (
            <div
              className="gym-location-table-content"
              key={
                item.gymName && item.facilikey
                  ? `${item.gymName}-${item.facilikey}`
                  : index
              }
            >
              <div>{item.gymName ? item.gymName : ""}</div>
              <div>{item.gymLocation ? item.gymLocation : ""}</div>

              <div style={{ overflowWrap: "anywhere" }}>
                <span>{item.gymMapLink ? item.gymMapLink : ""}</span>
              </div>
              <div>{item.facilikey ? item.facilikey : ""}</div>
              <div className="action-buttons">
                {!readOnly && (
                  <button
                    onClick={(e) => {
                      onEdit(e, item.gymCoordinates, item.gymContact);
                    }}
                    data-button-type="primary"
                    data-icon
                    data-icon-only
                  >
                    <SvgIcon
                      src={"/img/new-icons/edit-pencil.svg"}
                      noFilterOnLight={true}
                    />
                  </button>
                )}
                <button
                  data-button-type="secondary"
                  data-icon
                  data-icon-only
                  onClick={(e) => {
                    onTimingModal(e, item.gymCoordinates, item.gymContact);
                  }}
                >
                  <SvgIcon
                    src="/img/svg/time.svg"
                    width={15}
                    height={15}
                    alt={t("common:time")}
                  />
                </button>
                {!readOnly && (
                  <button
                    data-button-type="secondary"
                    data-icon
                    data-icon-only
                    onClick={(event) => {
                      onDelete(event, index);
                    }}
                  >
                    <SvgIcon
                      src="/img/new-icons/red-trash.svg"
                      width={15}
                      height={15}
                      alt={t("common:delete")}
                      noFilterOnLight
                    />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {!readOnly && (
        <div>
          <a
            role="button"
            data-button-type="outline"
            href="/coaching-portal/settings/gym-locations?addNewGym=true"
          >
            <span>{t("gymLocationDesktop.addNewGym")}</span>
          </a>
        </div>
      )}
    </div>
  );
};
